import styled from "styled-components";

export const Row = styled.div`
  display: flex;
  align-items: stretch;
  gap: 6px;

  @media (max-width: 700px) {
    flex-direction: column;
  }
`;

export const Stage = styled.div`
  flex: 1;
  background: #faf8f5;
  border: 1px solid #eee7dd;
  border-radius: 12px;
  padding: 16px 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

export const StageValue = styled.div`
  font-family: 'Aileron', 'Poppins', sans-serif;
  font-size: 26px;
  font-weight: 800;
  color: #111111;
  line-height: 1;
`;

export const StageLabel = styled.div`
  font-family: 'Aileron', 'Poppins', sans-serif;
  font-size: 12.5px;
  font-weight: 600;
  color: #6b6259;
`;

export const StagePct = styled.div`
  font-family: 'Aileron', 'Poppins', sans-serif;
  font-size: 11.5px;
  font-weight: 600;
  color: #8a7f74;
`;

export const Arrow = styled.div`
  display: flex;
  align-items: center;
  color: #cbbfb1;
  flex-shrink: 0;

  @media (max-width: 700px) {
    justify-content: center;
    transform: rotate(90deg);
  }
`;
